module.exports = __webpack_public_path__ + "static/img/ptd3.7e1510e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ptd/ptd3.png
// module id = 776
// module chunks = 0